import { render, staticRenderFns } from "./DeparturesPageSaoJose.vue?vue&type=template&id=0dcb0f3a&scoped=true&"
import script from "./DeparturesPageSaoJose.vue?vue&type=script&lang=js&"
export * from "./DeparturesPageSaoJose.vue?vue&type=script&lang=js&"
import style0 from "./DeparturesPageSaoJose.vue?vue&type=style&index=0&id=0dcb0f3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcb0f3a",
  null
  
)

export default component.exports